<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="filter">
            <filter-component
              :applyTranslate="false"
              :isRequiredFarms="true"
              :onlyFarmsFruits="true"
              :filterOfLots="true"
              :filterOfRibbons="true"
              @filter="handleFilter"
              @showHideLoading="showHideLoading"
              classFarms="col-12 col-md-6 col-lg-6 col-xl-3"
              classLots="col-12 col-md-6 col-lg-6 col-xl-3"
              classRibbons="col-12 col-md-6 col-lg-6 col-xl-3"
            >
              <template slot="prev">
                <select-component
                  :dataOptions="optionsFilter"
                  :initialSelection="optionSel"
                  @onChange="handleChangeSelected"
                  :labelSelect="`${$t('common_words.report_typeof')}: *`"
                  modelName="optionSel"
                  requireClass="required-options"
                  rowClass="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 pt-3"
                />
              </template>
            </filter-component>
          </el-collapse-item>
        </el-collapse>
      </card>
      <template
        v-if="
          tableData['ribbonsBalances'] &&
          tableData['ribbonsBalances'].length > 0
        "
      >
        <br />
        <report-ribbons-balances
          :farmList="tableData['ribbonsBalances'][0].farms"
          :dataFarm="farmData['ribbonsBalances']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="
          tableData['ribbonsBalancesByTotal'] &&
          tableData['ribbonsBalancesByTotal'].length > 0
        "
      >
        <br />
        <report-ribbons-balances-by-totals
          :farmList="tableData['ribbonsBalancesByTotal'][0].farms"
          :dataFarm="farmData['ribbonsBalancesByTotal']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="
          tableData['balanceVariablesByRibbon'] &&
          tableData['balanceVariablesByRibbon'].length > 0
        "
      >
        <br />
        <report-balance-var-ribbon
          :farmList="tableData['balanceVariablesByRibbon'][0].farms"
          :dataFarm="farmData['balanceVariablesByRibbon']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="
          tableData['balanceVarByRibbonTotal'] &&
          tableData['balanceVarByRibbonTotal'].length > 0
        "
      >
        <br />
        <report-balance-var-ribbon-totals
          :farmList="tableData['balanceVarByRibbonTotal'][0].farms"
          :dataFarm="farmData['balanceVarByRibbonTotal']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="
          tableData['reportByAgeAndWeek'] &&
          tableData['reportByAgeAndWeek'].length > 0
        "
      >
        <br />
        <report-by-age-week
          :farmList="tableData['reportByAgeAndWeek'][0].farms"
          :dataFarm="farmData['reportByAgeAndWeek']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
      <template
        v-if="
          tableData['reportByAgeAndWeekTotal'] &&
          tableData['reportByAgeAndWeekTotal'].length > 0
        "
      >
        <br />
        <report-by-age-week-total
          :farmList="tableData['reportByAgeAndWeekTotal'][0].farms"
          :dataFarm="farmData['reportByAgeAndWeekTotal']"
          @handleChangeMenuSelected="handleChangeMenuSelected"
          @exportToExcel="exportToExcel"
        />
      </template>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { MixinExport } from 'src/mixins/mixin-export';
import Filter from 'src/components/Filter/Filters.vue';
import MixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import ReportRibbonsBalances from './RibbonsBalances/ReportRibbonsBalances.vue';
import ReportRibbonsBalancesByTotals from './RibbonsBalances/ReportRibbonsBalancesByTotals.vue';
import ReportBalanceVariableByRibbon from './BalanceVariablesByRibbon/ReportBalanceVariableByRibbon.vue';
import ReportBalanceVariableByRibbonTotals from './BalanceVariablesByRibbon/ReportBalanceVariableByRibbonTotals.vue';
import ReportByAgeAndWeek from './ReportByAgeAndWeek/ReportByAgeAndWeek.vue';
import ReportByAgeAndWeekTotal from './ReportByAgeAndWeek/ReportByAgeAndWeekTotal.vue';
import Select from 'src/components/Selects/Select.vue';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  components: {
    [Filter.name]: Filter,
    [ReportRibbonsBalances.name]: ReportRibbonsBalances,
    [ReportRibbonsBalancesByTotals.name]: ReportRibbonsBalancesByTotals,
    [ReportBalanceVariableByRibbon.name]: ReportBalanceVariableByRibbon,
    [ReportBalanceVariableByRibbonTotals.name]:
      ReportBalanceVariableByRibbonTotals,
    [ReportByAgeAndWeek.name]: ReportByAgeAndWeek,
    [ReportByAgeAndWeekTotal.name]: ReportByAgeAndWeekTotal,
    [Select.name]: Select,
  },
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },

    optionsFilter() {
      return this.concatAll([
        {
          id: 1,
          name: i18n.t('production.ribbon_balance'),
          option: 'ribbonsBalances',
          file: 'reporte_saldos_cinta',
          notFoundMessage: i18n.t('message.production.not_found_msg'),
        },
        {
          id: 2,
          name: i18n.t('production.ribbon_balances_total'),
          option: 'ribbonsBalancesByTotal',
          file: 'reporte_saldos_cinta_totales',
          notFoundMessage: i18n.t('message.production.not_found_msg_balance'),
        },
        {
          id: 3,
          name: i18n.t('production.ribbon_variable_balance'),
          option: 'balanceVariablesByRibbon',
          file: 'reporte_saldos_variables_cinta',
          notFoundMessage: i18n.t('message.production.not_found_msg_ribbon'),
        },
        {
          id: 4,
          name: i18n.t('production.ribbon_variable_balance_total'),
          option: 'balanceVarByRibbonTotal',
          file: 'reporte_saldos_variables_cinta_totales',
          notFoundMessage: i18n.t(
            'message.production.not_found_msg_ribbon_total'
          ),
        },
        {
          id: 5,
          name: i18n.t('production.harvest_by_age_week'),
          option: 'reportByAgeAndWeek',
          file: 'reporte_cosecha_edad_semana',
          notFoundMessage: i18n.t('message.production.not_found_msg_harvest'),
        },
        {
          id: 6,
          name: i18n.t('production.harvest_by_age_week_total'),
          option: 'reportByAgeAndWeekTotal',
          file: 'reporte_cosecha_edad_semana_totales',
          notFoundMessage: i18n.t(
            'message.production.not_found_msg_harvest_total'
          ),
        },
      ]);
    },
  },

  data() {
    return {
      activeName: 'filter',
      optionSel: [],
      valueCollapse: null,
      tableData: {
        ribbonsBalances: [],
      },
      farmData: [],
    };
  },
  mixins: [MixinExport, MixinMasters, MixinMenu],
  methods: {
    handleChangeSelected(data) {
      this.optionSel = [...data.selects];
    },

    handleChangeMenuSelected(data) {
      this.showHideLoading(true);
      const selected = { ...this.tableData[data.option][0] };
      const dataSelected = [];
      dataSelected['farm'] = data.id;
      Object.keys(selected).forEach((key) => {
        let dataCutting = {};
        let dataPocket = {};
        let dataRinging = {};

        try {
          dataCutting = selected[key]['cutting'][data.id];
        } catch (error) {
          //
        }

        try {
          dataPocket = selected[key]['pocket'][data.id];
        } catch (error) {
          //
        }

        try {
          dataRinging = selected[key]['ringing'][data.id];
        } catch (error) {
          //
        }

        if (key !== 'data' && key !== 'totalColumns')
          dataSelected[key] = selected[key][data.id];
        else {
          dataSelected[key] = {
            cutting: dataCutting,
            pocket: dataPocket,
            ringing: dataRinging,
          };
        }
      });
      this.$set(this.farmData, data.option, dataSelected);
      this.showHideLoading();
    },

    handleFilter(data) {
      this.dataFilter = { ...data };
      if (this.optionSel.length == 0)
        return this.validationInputsRequired('options');
      else this.loadReport();
    },

    loadReport() {
      this.showHideLoading(true);
      this.tableData = {
        ribbonsBalances: [],
      };
      this.dataFilter.route = 'cutting/advancedreport';
      this.dataFilter.optionSel = this.optionSel;

      Axios.postMasters(this.dataFilter)
        .then((response) => {
          this.optionSel.forEach((sel) => {
            const optionFilter = this.optionsFilter.find(
              (option) => option.id == sel
            );
            const dataResponse = response.data.data.find(
              (result) => result[optionFilter.option]
            );
            if (
              Object.keys(dataResponse[optionFilter.option].rows).length == 0
            ) {
              SweetAlert.warning(optionFilter.notFoundMessage);
              this.$set(this.tableData, optionFilter.option, []);
            } else {
              this.$set(this.tableData, optionFilter.option, [
                dataResponse[optionFilter.option],
              ]);
            }
          });
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          this.showMessageErrors(error);
        });
    },

    exportToExcel(data) {
      const optionFilter = this.optionsFilter.find(
        (option) => option.id === data.optionBackend
      );
      this.Excel(
        {
          route: 'cutting/advancedreport/excel',
          name_file: `${optionFilter.file}.xlsx`,
          farm: [this.farmData[data.optionFront]['farm']],
          bySel: this.dataFilter.bySel,
          datei: this.dataFilter.datei,
          datef: this.dataFilter.datef,
          lot: this.dataFilter.lot,
          ribbon: this.dataFilter.ribbon,
          optionSel: [data.optionBackend],
          typeReport: [data.optionFront],
        },
        'POST',
        true
      )
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
    handleCollapse(val) {
      this.valueCollapse = val;
    },
  },
  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },
};
</script>
<style>
.card .table:not(.not-last-td) tbody td:last-child,
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}
</style>
